export default __webpack_public_path__ + "static/media/easyFive.c706b98e.png";